import { pushEvent } from '../../client/data-layer';
import { ContentTypes } from 'src/areas/expert/types';

export const trackCategoryPageExpertCarouselCard = (
  pageUrl?: string,
  cardType?: ContentTypes
) => {
  pushEvent('productCollectionExpertCarouselCardClick', {
    pageUrl,
    cardType,
  });
};

export const trackCategoryPageExpertCarouselInfoList = (
  pageUrl?: string,
  cardType?: string
) => {
  pushEvent('productCollectionExpertCarouselInfoClick', {
    pageUrl,
    cardType,
  });
};
